<template>
	<div class="over-view">
	    <div class="qrcode-wrap">
			<img src="../assets/images/order-manage/ic_order_off.png" class="delete" @click="deletePay">
	        <p class="code-box">
	        	<qrcode  :value="qrcodeUrl" :options="{ size: 202 }" ></qrcode>
	        </p>
	        <p class="charge-money"><span>¥</span>{{chargeMoney}}</p>
	        <p class="wechat-sao">微信扫一扫{{tips}}</p>
	        
	    </div>
	</div>
</template>

<script>
	import Qrcode  from '@xkeshi/vue-qrcode'
    export default {
        data(){
            return{
				
            }
        },
		
		components: {
			Qrcode
		},
		props:{
            qrcodeUrl: {
                type: String,
            },
			
			chargeMoney: {
			    type: String,
			},
			
			tips:{
				type: String,
			}
		},
        methods:{
            deletePay() {
				this.$emit('deletePay');
            }  
        },
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	.over-view{width:100%;height:100%;background:rgba(0,0,0,0.5);position:fixed;left:0;top:0;z-index: 10}
	.qrcode-wrap{ width: 380px;height: 420px;background: #fff;margin: 0 auto;margin-top: 15%;}
	.delete{width: 14px;height: 14px;border: none;float: right;margin-right: 11px;margin-top: 11px}
	.code-box{width:236px;height:236px;padding-top:40px;margin:auto;}
	.wechat-sao{text-align: center;height: 21px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(76,76,76,1);line-height:21px;}
	.charge-money{text-align: center;height: 42px;font-size:30px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(255,134,48,1);line-height:42px;margin-top: 56px;margin-bottom: 12px;}
	.charge-money span{font-size:18px; }
</style>
